module.exports = __webpack_public_path__ + "static/media/plan-piloto-mvs-wom-150-gigas.e1e642a5.svg";